import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Colours from '../tokens/colours';
import H1 from '../atoms/H1';
const getStyles = createUseStyles({
    root: {
        backgroundColor: Colours.white,
        padding: [16, 12]
    }
});
const PageHeader = ({ children, className }) => {
    const styles = getStyles();
    return (React.createElement(H1, { className: classNames(styles.root, className) }, children));
};
export default PageHeader;
//# sourceMappingURL=PageHeader.js.map